<template>
  <div style="min-height: 100vh;">
    <div class="match-list">
      <div class="list">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getCrmAccountUnionMatchList">
            <div class="item" v-for="(item, index) in list" :key="index" @click="goMatch(item.id)">
              <div class="bgi">
                <img :src="imageView(item.backgroundImage2, 0, 0)" />
                <div class="status">{{ item.state }}</div>
                <div class="t1">
                  {{ item.chineseName }}
                </div>
              </div>
              <div class="match-info">
                <div class="location" v-if="item.location">{{ `${item.location}` }}</div>
                <div class="time">
                  比赛时间：{{ getFormatDate(item.beginDate) }}-{{ getFormatDate(item.endDate) }}
                  <img src="../../assets/grey-right.png" style="width: 13px; height: 13px;">
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { List, PullRefresh } from 'vant'
Vue.use(List).use(PullRefresh)
import { getCrmAccountUnionMatchList, getCrmAccountUnionMatchSignupList } from "@/api/match";
import { DateUtil, QNImageUtil } from "@/utils";
export default {
  data() {
    return {
      accountId: '',
      list: [],
      isLoading: false,
      loading: false,
      finished: false,
      pageSize: 10,
      pageNum: 1
    }
  },
  mounted() {
    this.accountId = this.$route.params.accountId
    // this.getCrmAccountUnionMatchSignupList()
    // this.getCrmAccountUnionMatchList()
  },
  methods: {
    getCrmAccountUnionMatchList(state) {
      const params = {
        accountId: this.accountId,
        state: state,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      getCrmAccountUnionMatchList(params).then(res => {
        if (res) {
          const { data } = res
          this.list = this.list.concat(data.list)
          if (this.pageSize > data.list.length) {
            this.finished = true
          } else {
            this.pageNum++
          }
          this.isLoading = false
        }
      })
    },
    getCrmAccountUnionMatchSignupList() {
      const params = {
        accountId: this.accountId
      }
      getCrmAccountUnionMatchSignupList(params).then(res => {
        if (res) {
          const { data } = res
          console.log(data)
        }
      })
    },
    goMatch(id) {
      this.$router.push('/union-match/match-overall?unionMatchId=' + id)
    },
    imageView(img, w, h) {
      if (!img) return ''
      return QNImageUtil.imageView(img, w, h)
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    onRefresh() {
      this.list = []
      this.getCrmAccountUnionMatchList()
    }
  }
}
</script>

<style scoped lang="scss">
.match-list {
  padding: 16px 12px;
  background-color: #FFFFFF;

  .list {
    .item {
      .bgi {
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        height: 143px;
        background-size: 100% 100%;

        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: center;
        }

        .status {
          position: absolute;
          top: 0;
          left: 0;
          width: 50px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          background-color: #12DB63;
          color: #FFFFFF;
          font-size: 12px;
          border-radius: 4px 0 4px 0;
        }

        .t1 {
          position: absolute;
          bottom: 0px;
          width: 100%;
          padding: 8px;
          background-color: rgba($color: #7F7F7F, $alpha: .5);
          color: #FFFFFF;
          font-size: 14px;
          padding-left: 12px;
          box-sizing: border-box;
        }
      }

      .match-info {
        height: 44px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .location {
          width: 92px;
          height: 24px;
          line-height: 24px;
          background-color: #E7EFFE;
          border-radius: 4px;
          color: #1565FC;
          font-size: 11px;
          text-align: center;
          overflow: hidden;
          text-wrap: none;
        }

        .time {
          color: #8C8C8C;
          font-size: 13px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
